/* eslint-env browser */
import * as React from 'react'

import withTranslator from '../TranslatorProvider'

const PropTypes = require('prop-types')

function getDisplayValue(spec) {
  const value = spec.stringValue || spec.doubleValue
  switch (spec.specId) {
    case 'COLOR':
    case 'ROD_PACKED_LENGTH':
    case 'ROD_TIGE_NUMBER':
    case 'HOOK':
    case 'HOOKS':
    case 'HOOK_SIZE':
    case 'DIVES_TO':
    case 'LENGTH':
    case 'RUNNING_DEPTH':
    case 'TYPE':
    case 'WEIGHT':
      return value
    case 'LENGTH_CM':
    case 'ROD_PACKED_LENGTH_CM':
      return `${value}cm`
    case 'LENGTH_IN':
    case 'ROD_PACKED_LENGTH_IN':
      return `${value}in`
    case 'WEIGHT_G':
      return `${value}g`
    case 'WEIGHT_OZ':
      return `${value}oz`
    default:
      return null
  }
}

function getItemProp(spec) {
  const value = spec.stringValue || spec.doubleValue
  switch (spec.specId) {
    case 'COLOR':
      return { itemProp: 'color', content: value }
    case 'WEIGHT':
      return { itemProp: 'weight', content: value }
    case 'WEIGHT_G':
      return { itemProp: 'weight', content: `${value} g` }
    case 'WEIGHT_OZ':
      return { itemProp: 'weight', content: `${value} oz` }
    case 'LENGTH':
      return { itemProp: 'width', content: value }
    case 'LENGTH_CM':
      return { itemProp: 'width', content: `${value} cm` }
    case 'LENGTH_IN':
      return { itemProp: 'width', content: `${value} in` }
    default:
      return {}
  }
}

class SpecsList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { specs, translate } = this.props
    const filteredSpecs = specs.filter(elt => !!getDisplayValue(elt))

    return (
      <ul className="is-size-7">
        {filteredSpecs.map(spec => (
          <li key={spec.id}>
            {translate(`gear.productSpecs.labels.${spec.specId}`)}
            <b className="has-padding-left-small" {...getItemProp(spec)}>
              {getDisplayValue(spec)}
            </b>
          </li>
        ))}
      </ul>
    )
  }
}

SpecsList.propTypes = {
  translate: PropTypes.func.isRequired,
  specs: PropTypes.array.isRequired,
}

SpecsList.defaultProps = {}

module.exports = withTranslator(SpecsList)
